import Box from '@/Atoms/Box/Box';
import CCText from '@/Atoms/CCText/CCText';
import SlideModal from '@/Atoms/SlideModal';
import CCColors from '@/Utils/CCColors';
import {FontSizes, WINDOW_WIDTH} from '@/Utils/Dimensions';
import {StyleSheet} from 'react-native';
import phoneCall from '../../../Assets/Images/Svgs/phoneCall.svg';
import {Image} from 'react-native';
import callBgPattern from '../../../Assets/Images/Svgs/callBgPattern.svg';

const SupportComponent = ({showCall, setShowCall}) => {
  return (
    <SlideModal
      visible={showCall}
      onClose={() => setShowCall(false)}
      type="center"
      minWidth={WINDOW_WIDTH / 3}
      customHeaderStyle={styles.modalHeader}
      contentPadding={0}
      modalHeaderTitle={
        <Box flexDirection="row" alignItems="center" justifyContent="center">
          <Box marginRight={8} style={styles.header}>
            <Image source={phoneCall} style={styles.img} />
          </Box>
          <CCText fontWeight={500} fontSize={FontSizes[20]}>
            Call Support
          </CCText>
        </Box>
      }>
      <Box
        flexDirection="column"
        alignItems="flex-start"
        justifyContent="center"
        style={styles.wrapper}>
        <Image source={callBgPattern} style={styles.bgPattern} />
        <Box style={styles.container1} gap={4}>
          <CCText fontWeight={500} fontSize={FontSizes[16]}>
            🇮🇳 +91 80 4711 0244
          </CCText>
          <CCText
            color={CCColors.TextColor.GreyText}
            fontWeight={500}
            fontSize={FontSizes[12]}>
            Mon–Fri: 10AM–10PM IST | Sat–Sun: 10AM–7PM IST
          </CCText>
        </Box>
        <Box style={styles.container2} gap={4}>
          <CCText fontWeight={500} fontSize={FontSizes[16]}>
            🌍 +1 213 556 4363
          </CCText>
          <CCText
            color={CCColors.TextColor.GreyText}
            fontWeight={500}
            fontSize={FontSizes[12]}>
            Mon–Fri: 10AM–9PM EST | Sat–Sun: 10AM–7PM EST
          </CCText>
        </Box>
        <Box alignItems="center" justifyContent="center" style={styles.footer}>
          <CCText fontWeight={500} fontSize={FontSizes[12]}>
            Standard carrier rates may apply.
          </CCText>
        </Box>
      </Box>
    </SlideModal>
  );
};

export default SupportComponent;

const styles = StyleSheet.create({
  header: {
    padding: 10,
    backgroundColor: CCColors.Primary.Default,
    borderRadius: 20,
    alignItems: 'center',
    justifyContent: 'center',
  },
  img: {
    height: 20,
    width: 20,
  },
  wrapper: {
    borderColor: CCColors.BorderLight,
    borderTopWidth: 1,
    position: 'relative',
  },
  container1: {
    paddingLeft: 38,
    paddingTop: 24,
    paddingBottom: 16,
  },
  container2: {
    paddingLeft: 38,
    paddingBottom: 24,
  },
  footer: {
    backgroundColor: CCColors.CCTableBg,
    padding: 8,
    width: '100%',
  },
  bgPattern: {
    width: 119,
    height: 108,
    position: 'absolute',
    right: 0,
    top: 0,
    zIndex: -10,
  },
  modalHeader: {
    paddingTop: 24,
    paddingBottom: 15,
    paddingHorizontal: 32,
  },
});
